import { inject, Injectable } from '@angular/core';
import { ShowsStore } from '../../features/shows/core/stores/ShowsStore';
import { ShowsUtils } from '../../features/shows/core/utils/ShowsUtils';
import { StatisticsService } from '../../features/statistics/core/services/StatisticsService';
import { BackgroundAction } from '../classes/BackgroundAction';
import { BroadcastChannelMessageTypes } from '../enums/BroadcastChannelMessageTypes';
import { BroadcastChannelService } from './BroadcastChannelService';

@Injectable({
  providedIn: 'root'
})
export class BackgroundActionsService {

  public readonly showsStatisticsAction: BackgroundAction;
  public readonly updateShowVisibilityFlagsAction: BackgroundAction;
  public readonly pingCustomerScreen: BackgroundAction;
  public readonly pongCustomerScreen: BackgroundAction;

  private readonly _statisticsService = inject(StatisticsService);
  private readonly _showsStore = inject(ShowsStore);
  private readonly _broadcastChannelService = inject(BroadcastChannelService);

  public constructor() {
    this.showsStatisticsAction = new BackgroundAction(
      30,
      () => this._statisticsService.getShowsStatistics().subscribe()
    );

    this.updateShowVisibilityFlagsAction = new BackgroundAction(
      30,
      () =>
        this._showsStore.shows.update(shows => shows.map(s => ShowsUtils.updateShowVisibilityFlags(s)))
    );

    this.pingCustomerScreen = new BackgroundAction(
      1,
      () =>
        this._broadcastChannelService.cashChannelPostMessage(
          {
            type: BroadcastChannelMessageTypes.PING,
            data: {}
          }
        )
    );
  }
}
